<template>
  <!-- end of row -->
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab :title="$t('attendance.attendances_absence_record')" active>
              <data-table :edit-item="editItem" v-if="usertype==='student'"/>
              <admin-data-table v-else/>
            </b-tab>
            <!-- <b-tab @click="newItem= {}" :title="$t('site.add')" v-if="usertype=='admin'" >
              <my-form :new-item="newItem" />
            </b-tab> -->
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>

<script>
import Auth from '@/Apis/Auth';
import DataTableVue from "./components/DataTable.vue";
import AdminDataTableVue from "./components/AdminDataTable.vue";
// import FormVue from "./components/Form.vue";
export default {
  name: "OnlineSessionAttendanceIndex",
  components: {
    "data-table": DataTableVue,
    "admin-data-table":AdminDataTableVue
    // "my-form": FormVue,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
      usertype:Auth.USER.account_type
    };
  },
  methods: {
    editItem(data) {
      this.newItem = data.item;
      this.tab = 1;
    },
  },
};
</script>
